document.addEventListener("DOMContentLoaded", () => {
    var ProductsSwiper = new Swiper('.pro-col-list', {
      slidesPerView: 'auto',
      pagination: {
        el: '.pro-col-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.pro-col-next',
        prevEl: '.pro-col-prev',
      },
    });

    const btnList = document.querySelectorAll('.col-nav-item')
    const productList = document.querySelectorAll('.pro-col-list')

    btnList.forEach(btn => {
      btn.addEventListener('click', function() {
        const index = btn.getAttribute('index')
        btnList.forEach(el => el.classList.remove('active'));
        btn.classList.add('active')

        productList.forEach(item => {
          const num = item.getAttribute('index')

          if (index == num) {
            item.classList.add('active')
          } else {
            item.classList.remove('active')
          }

        })

      })
    })

});